import config from '../../constants';
import { countries } from '../../constants/countries';

export const organizationColumns = {
  NAME: 'name',
  AMOUNT_RAISED: 'raisedAmount',
  AMOUNT_RAISED_ONLINE: 'raisedAmountOnlineOnly',
  CAMPAIGNS_TOTAL: 'campaignCount',
  CAMPAIGNS_ACTIVE: 'campaignLiveCount',
  PAYMENT_CONNECTED: 'paymentPlatforms',
  CURRENCY: 'currency',
  COUNTRY: 'country',
  PAYMENT_PLATFORM: 'paymentPlatformLink'
};

export const organizationAvailableFiltersKeys = [
  organizationColumns.COUNTRY,
  organizationColumns.CAMPAIGNS_ACTIVE,
  organizationColumns.CAMPAIGNS_TOTAL,
  organizationColumns.AMOUNT_RAISED,
  organizationColumns.AMOUNT_RAISED_ONLINE
];

export const i18nKeys = {
  PAGE_TITLE: 'organization.title',
  DASHBOARD_ACTION: 'organization.dashboard-action',
  EDIT_ACTION: 'organization.edit-action',
  ADD_TO_EVENTS_ACTION: 'organization.add-to-events-action',
  VIEW_ACTION: 'organization.view-action'
};

export const stripeName = 'stripe';

export const stripeLink = 'https://stripe.com/au';

// The compliance page itself. Kept out of complianceComponents below so that hiding the
// New Zealand fields does not also clear the compliance object that the United Kingdom
// HMRC charity reference lives in.
export const compliancePagePath = 'compliance';

// Optional, United Kingdom only, and edited on the compliance page. The UK charity
// reference number is the organisation's `taxId`, edited on the about page.
export { hmrcCharityReferencePath } from './swiftaidConnection/constants';

// Alternate tax IDs and the authorised signature are New Zealand only.
export const complianceComponents = [
  'compliance.alternateTaxId1',
  'compliance.alternateTaxId2',
  'compliance.authorizedPerson.name',
  'compliance.authorizedPerson.title',
  'compliance.authorizedPerson.signatureImagePath'
];

// The compliance page carries the New Zealand receipt fields and the United Kingdom
// HMRC charity reference, so it is offered for either country. The United
// Kingdom is gated on the feature flag that also controls whether GB can be selected.
export const isCompliancePageVisible = (country, isUkCharityEnabled) =>
  countries[country] === countries.NZ ||
  (countries[country] === countries.GB && !!isUkCharityEnabled);

export const orgDetailComponents = [
  'organizationDetilHeader',
  'name',
  'legalName',
  'urlPath',
  'taxId',
  'template.value.hasDGR',
  'address.city',
  'address.street',
  'address.state',
  'address.postcode',
  'timezone'
];

export const organizationAboutValidationModels = {
  country: {
    required: true
  },
  name: {
    required: true,
    maxLength: true,
    length: config.ORGANIZATION_NAME_MAX_LENGTH
  },
  legalName: {
    required: true,
    maxLength: true,
    length: config.ORGANIZATION_NAME_MAX_LENGTH
  },
  subdomain: {
    required: true,
    maxLength: true,
    length: config.URL_PATH_MAX_LENGTH
  },
  street: {
    required: true,
    maxLength: true,
    length: config.FORMBUILDER_ADDRESS.STREET_MAX_LENGTH
  },
  city: {
    required: true,
    maxLength: true,
    length: config.FORMBUILDER_ADDRESS.CITY_MAX_LENGTH
  },
  state: {
    required: true,
    maxLength: true,
    length: config.FORMBUILDER_ADDRESS.STATE_MAX_LENGTH
  },
  // postCode moved to getOrganizationPostcodeValidationModel in constants/countries,
  // since its format is country-specific.
  timeZone: {
    required: true
  }
};

export const organizationComplianceValidationModels = {
  complianceAuthorizedPersonName: {
    required: true
  },
  complianceAuthorizedPersonTitle: {
    required: true,
    maxLength: true,
    length: config.JOB_TITLE_MAX_LENGTH
  },
  complianceAuthorizedPersonSignature: {
    required: true
  }
};
